export enum HttpStatusCode {
    INTERNAL_SERVER_ERROR = 500,
    FORBIDDEN = 403,
    UNAUTHORIZED = 401,
}
